export const textEn =
  {
    order: "Payment Order",
    tit: "Payment methods",
    text1: "Pay by debit or credit card without the need to create a Paypal account.",
    text2: "All transactions are done securely through Paypal or Teachable platforms.",
    text3: "By clicking 'Checkout', you accept our",
    text4: "Sales and Return Policies.",
    button: "Checkout"
  };

export const textEs =
  {
    order: "Orden de pago",
    tit: "Métodos de pago",
    text1: "Paga con tarjeta débito o crédito sin necesidad de crear cuenta Paypal.",
    text2: "Toda la transacción se realiza de forma segura a través de las plataformas Paypal o Teachable.",
    text3: "Al hacer clic en 'Finalizar compra', aceptas nuestras",
    text4: "Políticas de venta y devolución.",
    button: "Finalizar compra"
  };
